import Advice from "components/common/Advice";

const CnpAssuranceAdvice = () => {
  return (
    <Advice
      title={"CNP Assurances. Abertos ao mundo, a você e ao Brasil."}
      paragraph={
        "Somos a maior seguradora francesa com 170 anos de tradição em proteger e cuidar das pessoas. Estamos presentes em mais de 19 países da Europa e da América Latina. Humanizamos o mercado de seguridade no Brasil e hoje acompanhamos a jornada de vida de ainda mais brasileiros."
      }
    />
  );
};

export default CnpAssuranceAdvice;
